import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const RetentionPeriodSchema = BigdesDefinitionSchema.extend({
    durationMonths: z.number().int().optional(),
});
export const CreateRetentionPeriodSchema = RetentionPeriodSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateRetentionPeriodSchema = RetentionPeriodSchema.partial();
